
import { makeStyles } from '@mui/styles';

const ERROR_COLOR_BORDER_TEXT = '#B3261E';
const THEME_COLOR_BASE = '#536DFE';
const FIELD_LABEL_COLOR = '#0C0644';

const styles = (theme) => ({

  container: () => {
    return  {
        display: 'flex',
        height: '100vh',
        width: '100%',
      
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'scroll',
    };
  },

  headerSpace: {
    width: '100%',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  actionPanel: ({ widgetTheme }) => {
    // const wt = widgetTheme;
    return  {
      display: 'flex',
      width: '100%',
      
      height: '50px',
      marginBottom: '42px',
      // borderTop: `${wt.borderWidth} ${wt.borderStyle} ${wt.grey3}`,
      // background: wt.grey4,
      // padding: wt.paddingLarge,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column !important',

    };
  },

  // 44 + 142 + 40 + 56 = 284
  content: () => {
    function getHeight () {
      return 'calc(100% - 32px)';
    }

    return {
      display: 'flex',
      flexDirection: 'column !important',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'hidden',
      width: '100%',
      height: getHeight(),

    	/* rest of css*/
      // overflowY: 'scroll',
      padding: '0px',
      /* for firefox*/
      scrollbarColor: 'transparent transparent',
      scrollbarWidth: '12px',

      '&::-webkit-scrollbar': {
          width: '12px',
          background: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
          borderradius: '5px',
      },

      '&:hover': {
          'scrollbarColor': '#D9D9D9 transparent',
      },
    };
  },

  privacy: {
    display: 'flex',
    // width: '75%',
    paddingLeft: '20px',
    textAlign: 'left',
    // marginTop: '24px',
    margin: '16px 0px',
    fontSize: '10px',
    color: '#666666',
  },

  privacyText: {
    width: '100%',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
 
  formFields: {
    display: 'flex',
    height: 'auto',
    flexDirection: 'column',
  },

  listSpaceContainer: {
    display: 'flex',
    flexDirection: 'column !important',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'calc(100% - 90px)',
    overflowY: 'scroll',

    '&:hover': {
        'scrollbarColor': '#D9D9D9 transparent',
    },
  },

  listSpace: {
    width: '70%',
    maxWidth: '320px',
  },

  list: () => {
    return  {
      display: 'flex',
      
      overflow: 'hidden',
      width: '100%',
      justifyContent: 'center',
    };
  },

  listContent: () => {
    return  {
      display: 'flex',
      flexWrap: 'wrap',
      width: '480px',
      justifyContent: 'flex-start',
      alignContent: 'center',
      columnGap: '5px',
    };
  },

  tile:  () => {
    return  {
      display: 'block',
      width: '70px',
      height: '70px',
    };
  },

  fieldRoot: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'stretch',
    height: 'auto',
    position: 'relative',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '4px',

    '& .MuiSvgIcon-root': {
      position: 'absolute',
      top: '18px',
      right: '6px',
    },
  },

  fieldLabel: {
    display: 'flex',
    minHeight: '16px',
    lineHeight: '20px',
    alignItems:' flex-end',
    margin: '0px',
    marginBottom: '4px',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
    },
    color: FIELD_LABEL_COLOR,
  },

  inputBase: () => {

    return {
      height: '40px',
           
      '&.MuiTextField-root': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        height: 'auto',
        marginBottom: '0px',
        marginTop: '0px',
      },

      '& .Mui-disabled fieldset': {
        color: '#666666',
        backgroundColor: '#DEDDDF',
      },

      '& .MuiInputBase-root': {
        height: '40px',
        borderRadius: '8px',
        border: '1px solid #DEDDDF !important',
        lineHeight: '20px',
        fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
        fontWeight: 300,
        fontSize: '14px',
        boxSizing: 'border-box',
        boxShadow: 'none',

        '& .MuiInputBase-input': {
          height: '40px',
          boxSizing: 'border-box',
        },

        '&.Mui-error': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: ERROR_COLOR_BORDER_TEXT,
          }
        },

        '& .MuiInputBase-input::placeholder': {
          color: '#666666',
          fontSize: '14px',
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`
        },

        '& fieldset': {
            border: '0px none #00000000',
        },

      },
  
      '& .MuiFormHelperText-root': {
       
        '&.Mui-error': {
          display: 'flex',
          alignItems: 'center',
          color: ERROR_COLOR_BORDER_TEXT,
          margin: 0,
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
          fontSize: '10px',
          fontWeight: 'bold',
          minHeight: '28px',
        
        }
      },
  
      '& .MuiOutlinedInput-root': {
  
        '&:hover fieldset': { 
          borderColor: THEME_COLOR_BASE, 
        },
  
        '&.Mui-focused fieldset': { 
          borderColor: THEME_COLOR_BASE, 
        },
  
      },
    };
  },


  inputBaseError: () => {
    return {
      marginTop: '0px !important',
     
      '&.MuiTextField-root': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        height: 'auto',
        marginBottom: '0px',
      },

      '& .Mui-disabled fieldset': {
        color: '#666666',
        backgroundColor: '#DEDDDF',
      },

      '& .MuiInputBase-root': {
        height: '40px',
        borderRadius: '8px',
        border: `1px solid ${ERROR_COLOR_BORDER_TEXT} !important`,
        lineHeight: '20px',
        fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
        fontWeight: 300,
        fontSize: '14px',
        boxSizing: 'border-box',
        boxShadow: 'none',

        '& .MuiInputBase-input': {
          height: '40px',
          boxSizing: 'border-box',
        },

        '&.Mui-error': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: ERROR_COLOR_BORDER_TEXT,
          }
        },

        '& .MuiInputBase-input::placeholder': {
          color: `${ERROR_COLOR_BORDER_TEXT}`,
          fontSize: '14px',
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`
        },

        '& fieldset': {
          height: '40px',
          border: '0px none #00000000',
        },

      },
  
      '& .MuiFormHelperText-root': {
        '&.Mui-error': {
          display: 'flex',
          alignItems: 'center',
          color: ERROR_COLOR_BORDER_TEXT,
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
          fontSize: '10px',
          fontWeight: 'bold',
          minHeight: '22px',
          margin: 0,
          marginTop: '4px',
        }
      },
  
      '& .MuiOutlinedInput-root': {
  
        '&:hover fieldset': { 
          borderColor: THEME_COLOR_BASE, 
        },
  
        '&.Mui-focused fieldset': { 
          borderColor: THEME_COLOR_BASE, 
        },
  
      },
    };
  },

  inputBaseAutofill: () => {
    return {
      height: '40px',
      marginTop: '0px !important',
      marginBottom: '12px !important',
      backgroundColor: '#DEDDDF',
      borderRadius: '8px',
      '& .Mui-disabled fieldset': {
        color: '#666666',
      },

      '& .MuiInputBase-root': {
        height: '40px',
        
        borderRadius: '8px',
        // border: '1px solid #DEDDDF !important',
        lineHeight: '20px',
        fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
        fontWeight: 300,
        fontSize: '14px',
        boxSizing: 'border-box',
        boxShadow: 'none',

        '&.Mui-error': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: ERROR_COLOR_BORDER_TEXT,
          }
        },

        '& .MuiInputBase-input::placeholder': {
          color: '#666666',
          fontSize: '14px',
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`
        },

        '& fieldset': {
            border: '0px none #00000000',
        },

      },
  
      '& .MuiFormHelperText-root': {
       
        '&.Mui-error': {
          display: 'flex',
          alignItems: 'center',
          color: ERROR_COLOR_BORDER_TEXT,
          margin: 0,
          fontFamily: `'Font-Regular', 'Regular', ${theme.typography.fontFamily} !important`,
          fontSize: '10px',
          fontWeight: 'bold',
          minHeight: '28px',
        
        }
      },
  
      '& .MuiOutlinedInput-root': {
        '&:hover fieldset': { 
          borderColor: THEME_COLOR_BASE, 
        },
  
        '&.Mui-focused fieldset': { 
          borderColor: THEME_COLOR_BASE, 
        },
  
      },
    };
  },

  textInput: {
    position: 'relative',
    '&.Mui-disabled': {
      '-webkit-text-fill-color': '#666666',
    }
  },

  radioGroup: {
    '&.MuiFormControl-root': {
      marginTop: '16px',
    }
  },

  selectUI: {
    marginTop: '0px !important',
    marginBottom: '2px !important',
  },

  mobile: {
    marginTop: '4px !important',
  },

  date: {
    display: 'flex',
    flexDirection: 'column !important',
    width: '100%',
    marginTop: '8px',
    marginBottom: '8px',
  },

  optinItem: {
    marginTop: '12px',
    marginBottom: '12px',
    display: 'flex',
    flexDirection: 'row !important',
    alignItems: 'flex-start',
  },

  optinItemCheck: {
    width: '12px',
    height: '12px',
    padding: '0px',

    '&.MuiCheckbox-root': {
      padding: '0px',
    },

    '&.MuiButtonBase-root': {
      borderRadius: '4px',
    },

    '& .MuiSvgIcon-root ': {
       fontSize: '14px',
       fill: '#FFFFFF',
    }
  },

  optinItemText: {
    marginLeft: '8px',
    // height: '30px',
    fontSize: '10px',
    lineHeight: '10px',
    color: '#666666',
    letterSpacing: '.25px',
    cursor: 'pointer',
  },

  errorText: () => {
    const style = {
      color: '#d32f2f',
      fontSize: '12px',
      margin: '4px 14px 0px',
    };
    return style;
  },

  checkUntick: {
    display: 'flex',
    minWidth: '12px',
    boxSizing: 'border-box',
    width: '12px',
    height: '12px',
    borderRadius: '4px',
    border: '1px solid #666666',
  },

  checkTicked: {
    display: 'flex',
    boxSizing: 'border-box',
    width: '12px',
    minWidth: '12px',
    height: '12px',
    borderRadius: '4px',
    border: '1px solid #666666',
    backgroundColor: '#666666',
  }

});

export default styles;
export const useStyles = makeStyles(styles);
